import { render, staticRenderFns } from "./TabStockExpired.vue?vue&type=template&id=5ae10232&scoped=true&"
import script from "./TabStockExpired.vue?vue&type=script&lang=js&"
export * from "./TabStockExpired.vue?vue&type=script&lang=js&"
import style0 from "./TabStockExpired.vue?vue&type=style&index=0&id=5ae10232&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae10232",
  null
  
)

export default component.exports